// This optional code is used to register a service worker.
// The unregister function is used to unregister a previously registered service worker.

// To learn more about the benefits of service workers, read https://bit.ly/CRA-PWA

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
